import Styles from './assets/style.scss';
import { IIndeterminateLoading } from './entities/IIndeterminateLoading';

const BCIndeterminateLoading = (props: IIndeterminateLoading) => (
	<div
		className={Styles.progressContainer}
		style={props.styles}
	>
		<div className={Styles.progressMaterializecss}>
			<div className={Styles.indeterminate}></div>
		</div>
	</div>
);
export default BCIndeterminateLoading;
